import { render } from "./users.vue?vue&type=template&id=95f274e0&ts=true"
import script from "./users.vue?vue&type=script&lang=ts"
export * from "./users.vue?vue&type=script&lang=ts"

import "./users.vue?vue&type=style&index=0&id=95f274e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__